import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {ServerService} from './ServerService';
@Injectable({providedIn: 'root'})
export class NpsService extends ServerService {
  constructor(private httpCliente: HttpClient) {super(httpCliente);}
  obtenha(token: string): Promise<any> {return super.obtenha('/nps/publica/' + encodeURIComponent(token), {});}
  responda(token: string, resposta: {nota: number; comentario: string}): Promise<any> {
    return this.facaPost('/nps/publica/' + encodeURIComponent(token) + '/responder', resposta);
  }
}
